import { inferErrorCode } from '../routing'
import type { CatalogProduct, Route } from '../types'

const asTrimmedMediaValue = (value: unknown): string =>
  typeof value === 'string' ? value.trim() : ''

export const buildProductGallery = (productData: CatalogProduct | null) =>
  Array.from(
    new Set(
      [
        ...(productData?.mediaGallery ?? []),
        productData?.mediaVariants?.large ?? '',
        productData?.mediaVariants?.medium ?? '',
        productData?.mediaVariants?.small ?? '',
      ]
        .map(asTrimmedMediaValue)
        .filter(Boolean),
    ),
  )

export const resolveActiveProductImage = ({
  productGallery,
  selectedProductImage,
}: {
  productGallery: string[]
  selectedProductImage: string
}) => (productGallery.includes(selectedProductImage) ? selectedProductImage : (productGallery[0] ?? ''))

/**
 * Resolve active route error.
 *
 * Explains routing behavior, guards, and response semantics.
 */
export const resolveActiveRouteError = ({
  route,
  productLoading,
  productError,
  pageLoading,
  pageError,
}: {
  route: Route
  productLoading: boolean
  productError: string
  pageLoading: boolean
  pageError: string
}) => {
  if (route.mode === 'error') {
    return { code: route.code, message: '' }
  }
  if (!productLoading && productError) {
    return { code: inferErrorCode(productError, 404), message: productError }
  }
  if (!pageLoading && pageError) {
    const fallback = route.mode === 'preview' ? 404 : 500
    const code = inferErrorCode(pageError, fallback)
    return { code, message: code === 404 ? '' : pageError }
  }
  return null
}

export const hasHomeContentBlocks = (homePageData: unknown) =>
  Boolean(
    homePageData &&
      typeof homePageData === 'object' &&
      Array.isArray((homePageData as { content?: unknown[] }).content) &&
      ((homePageData as { content?: unknown[] }).content?.length ?? 0) > 0,
  )
